import React, { Component, Fragment } from "react";

export default class Ruleonpage extends Component {


    constructor(props) {
        super(props)
        this.state = {
            type: this.props.typeset,
            list : []

        }
        this.baseState = this.state 
    }

    componentDidMount() {
        // fetch('http://119.59.112.151:3000/getlotterysetting/1')
        //             .then(res => res.json())
        //             .then((content) => {
        //                 this.setState({
        //                     list: content
        //                 })
        //             })
        //      .catch(console.log);
    }


    render() {
        const type = this.state.type;
        const { list }  = this.state;
        console.log(type);
        if (type === 3 || type ===0) {      
            return (list.map((Ruleonpage, i) => (<Fragment>
                 <div className="box__condition-info">
                <h2><i className="fas fa-exclamation-circle"></i>เงื่อนไขการแทง</h2>
                <div className="row">      
                    <div className="col-md-12" id="content_teng_bon_3">
                        <h3>3 ตัวบน จ่าย: {Ruleonpage.Pize3_1OverBath} บาท</h3>
                        <p>
                            แทงขั้นต่ำต่อครั้ง : 1.00 <br />
                        </p> 
                    </div>  
                    <div className="col-md-12 d-none" id="content_teng_lang_2">
                            <h3>3 ตัวล่าง จ่าย:  {Ruleonpage.Pize3_2OverBath} บาท</h3>
                        <p>
                            แทงขั้นต่ำต่อครั้ง : 1.00 บาท <br />
                        </p>
                    </div>
                </div> 
            </div> 
            </Fragment>)))}
          else  if (type === 2) {
            return (<Fragment>
            <div className="box__condition-info">
                <h2><i className="fas fa-exclamation-circle"></i>เงื่อนไขการแทง</h2>
                <div className="row">
                    <div className="col-md-12 " id="content_teng_bon_2">
                            <h3>2ตัวบน จ่าย: {Ruleonpage.Pize2_1OverBath} </h3>
                        <p>
                            แทงขั้นต่ำต่อครั้ง : 1.00<br /> </p>
                    </div>                   
                    <div className="col-md-12 " id="content_teng_lang_2">
                            <h3>2ตัวล่าง จ่าย: {Ruleonpage.Pize2_2OverBath} </h3>
                        <p>
                            แทงขั้นต่ำต่อครั้ง : 1.00<br />
                     </p>
                    </div>
                </div>
                </div>  </Fragment> ) 
                }  

            else{          
             return (null)
            }
    }
}